import { useMutation } from 'react-query';
import * as yup from 'yup';
import i18n from '../../app/i18n';

import useForm from '../../lib/hooks/useForm';
import { createAccount } from './data';

const MIN_PW_LENGTH = 12;

const validationSchema = yup.object({
  firstName: yup
    .string()
    .trim()
    .required(i18n.t('createAccount:errors.blankName')),
  lastName: yup
    .string()
    .trim()
    .required(i18n.t('createAccount:errors.blankName')),
  password: yup
    .string()
    .required(i18n.t('createAccount:errors.blankPassword'))
    .min(
      MIN_PW_LENGTH,
      i18n.t('createAccount:errors.minLength', { length: MIN_PW_LENGTH }),
    ),
  email: yup
    .string()
    .required(i18n.t('createAccount:errors.blankEmail'))
    .email(i18n.t('createAccount:errors.invalidEmail')),
});

const useCreateAccount = () => {
  const { mutate } = useMutation(createAccount);

  const onSubmit = (values, { setFieldError }) => {
    const name = `${values.firstName} ${values.lastName}`;
    const parsedValues = {
      name,
      email: values.email,
      password: values.password,
    };

    mutate(parsedValues, {
      onSuccess: () => {
        window.location = '/activity';
      },
      onError: ({ response }) => {
        const { status } = response;
        const { errors } = response.data;

        if (status === 303) {
          // redirecting since user is already logged in
          window.location = '/activity';
        } else {
          Object.entries(errors).forEach(([key, value]) => {
            const errMsg =
              key === 'email'
                ? value.concat(i18n.t('createAccount:errors.emailErrorLink'))
                : value;

            return setFieldError(key, errMsg);
          });
        }
      },
    });
  };

  const initialValues = {
    firstName: '',
    lastName: '',
    email: '',
    password: '',
  };

  return useForm({
    initialValues,
    onSubmit,
    validationSchema,
  });
};

export default useCreateAccount;
